<template>
  <TechnicianDashboard
    v-if="sessionStore.loggedUser.technical === true"
  ></TechnicianDashboard>
  <GeneralDashboard v-else></GeneralDashboard>
</template>

<script setup lang="ts">
import { useSessionStore } from "@/store";
import GeneralDashboard from "./GeneralDashboard.vue";
import TechnicianDashboard from "./TechnicianDashboard.vue";

const sessionStore = useSessionStore();
</script>
